import * as Sentry from '@sentry/react'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

/** Sentry is opt-in: with no DSN provided at build time, `init` is skipped and every call below becomes a no-op. */
export function initSentry(): void {
  if (!SENTRY_DSN) return

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
  })
}

export function captureException(error: unknown, errorInfo?: { componentStack?: string | null }): void {
  if (!SENTRY_DSN) return

  Sentry.captureException(error, errorInfo ? { extra: { componentStack: errorInfo.componentStack } } : undefined)
}
